module.exports = __webpack_public_path__ + "static/media/location_icon.24e4037f.svg";